import { isReplayBlockedPath } from '@/lib/observability/replay-route-guard';
type Fbq = {
  (event: 'init', pixelId: string): void;
  (event: 'track', name: string, params?: Record<string, unknown>): void;
  callMethod?: (...args: Array<unknown>) => void;
  queue?: Array<Array<unknown>>;
  push?: (...args: Array<unknown>) => void;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID ?? '';

export type MetaPixelStandardEvent = 'PageView' | 'CompleteRegistration';

/**
 * Meta Pixel sends the full page URL: never on external app link, guest
 * app or sign-in pages, whose URLs carry link tokens (sharing review r7).
 */
export function metaPixelAllowedPath(pathname: string): boolean {
  return !isReplayBlockedPath(pathname);
}

export function metaPixelTrack(
  event: MetaPixelStandardEvent,
  params?: Record<string, unknown>
): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (!metaPixelAllowedPath(window.location.pathname)) {
    return;
  }
  const fbq = window.fbq;
  if (typeof fbq !== 'function') {
    return;
  }

  try {
    fbq('track', event, params);
  } catch {
    // Never let tracking break user flows
  }
}

export function metaPixelTrackCompleteRegistrationOnce(userId: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  if (!userId) {
    return;
  }

  const storageKey = `meta_pixel.complete_registration.${userId}`;
  try {
    if (sessionStorage.getItem(storageKey) === '1') {
      return;
    }
    sessionStorage.setItem(storageKey, '1');
  } catch {
    // If storage is unavailable, just fall back to best-effort tracking.
  }

  metaPixelTrack('CompleteRegistration');
}
